
import { CampaignFormData, WorkflowStep } from '../types';
import { handleGenerateConsolidatedReport, downloadAllReports } from '../utils/reportUtils';

interface UseWorkflowReportActionsProps {
  formData: CampaignFormData;
  steps: WorkflowStep[];
  campaignId: string | null;
  currentStep: number;
  consolidatedReport: string | null;
  setConsolidatedReport: (report: string) => void;
  setSelectedReport: (report: { title: string; content: string }) => void;
  setIsGeneratingConsolidated: (generating: boolean) => void;
}

export const useWorkflowReportActions = ({
  formData,
  steps,
  campaignId,
  currentStep,
  consolidatedReport,
  setConsolidatedReport,
  setSelectedReport,
  setIsGeneratingConsolidated
}: UseWorkflowReportActionsProps) => {
  const handleGenerateReport = () => {
    handleGenerateConsolidatedReport(
      formData,
      steps,
      campaignId,
      currentStep,
      setConsolidatedReport,
      setSelectedReport,
      setIsGeneratingConsolidated
    );
  };

  const handleDownloadReports = () => {
    downloadAllReports(formData, steps, consolidatedReport);
  };

  const handleShowConsolidatedReport = () => {
    setSelectedReport({
      title: 'Consolidated Political Campaign Analysis Report',
      content: consolidatedReport!
    });
  };

  return {
    handleGenerateReport,
    handleDownloadReports,
    handleShowConsolidatedReport
  };
};
